import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const categories = [
  {
    title: "PAPIER PEINT PREMIUM",
    subtitle: "CHICS INTERIEURS",
    image: "https://adawall.ma/uploads/wallpapers/icon/24104/24104-3/24104-3-int2.jpg",
    link: "/collections/papierpeint",
  },
  {
    title: "POSTERS",
    subtitle: "COZIFIER VOS MURS",
    image: "https://adawall.ma/uploads/posters/3-Fiji/FJ319/Interior.jpg",
    link: "/collections/poster",
  },
  {
    title: "BARDAGE CONTEMPORAIN",
    subtitle: "PANNEAUX N&M",
    image: "https://adawall.ma/uploads/adapanel/PS%20ADAPANEL%20VOL.2/807/807.jpg",
    link: "/collections/bardage",
  },
  {
    title: "EFFET MOULURE",
    subtitle: "LUXE ARCHI",
    image: "https://adawall.ma/uploads/moulding/MG2011/MG2011-1.jpg",
    link: "/collections/moulure",
  },
  {
    title: "COUSSINS & POUFS",
    subtitle: "CONFORT COUTURE",
    image: "https://adawall.ma/uploads/adahome/poufs/PUF301-1/PUF301-1-2.jpg",
    link: "/collections/coussinsETpoufs",
  },
  {
    title: "ACCESSOIRES DE MAISON",
    subtitle: "DÉCOR ÉLITE",
    image: "https://adawall.ma/uploads/accessoires/Place%20mats/ASK2103/3.jpg",
    link: "/collections/accessoires",
  },
];

const qualities = [
  {
    title: "Expertise et innovation",
    text: (
      <ul>
        <li>Accès à des collections exclusives et aux dernières tendances du revêtement mural</li>
        <li>Produits certifiés et respectueux de l’environnement</li>
        <li>Encres à base d’eau et impression de haute précision</li>
      </ul>
    ),
  },
  {
    title: "Qualité & Logistique",
    text: (
      <ul>
        <li>Finitions soignées et qualité d’impression exceptionnelle</li>
        <li>Stock permanent à Casablanca et livraison rapide dans tout le Maroc</li>
        <li>Contrôle qualité rigoureux à chaque étape</li>
      </ul>
    ),
  },
  {
    title: "Accompagnement personnalisé",
    text: (
      <ul>
        <li>Conseils sur-mesure pour chaque projet, résidentiel ou professionnel</li>
        <li>Service après-vente réactif et suivi client continu</li>
        <li>Pose professionnelle réalisée par des équipes qualifiées</li>
      </ul>
    ),
  },
];

function AboutUs() {
  const navigate = useNavigate();
  const [certifs, setCertifs] = useState([]);
  const [email, setEmail] = useState("");
  const [formStatus, setFormStatus] = useState({ loading: false, sent: false, error: "" });

  useEffect(() => {
    fetch("https://adawall.ma/php/api/certification.php")
      .then(res => res.json())
      .then(data => {
        if (Array.isArray(data)) setCertifs(data);
      });
  }, []);

  // Email validation helper
  const validateEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  // Form submit handler
  const handleCertifForm = async (e) => {
    e.preventDefault();
    setFormStatus({ loading: true, sent: false, error: "" });

    if (!validateEmail(email)) {
      setFormStatus({ loading: false, sent: false, error: "Veuillez entrer une adresse email valide." });
      return;
    }

    try {
      const res = await fetch("https://adawall.ma/php/api/send_certifs.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      const data = await res.json();
      if (data.success) {
        setFormStatus({ loading: false, sent: true, error: "" });
      } else {
        setFormStatus({ loading: false, sent: false, error: data.message || "Erreur lors de l'envoi. Veuillez réessayer." });
      }
    } catch (err) {
      setFormStatus({ loading: false, sent: false, error: "Erreur réseau. Veuillez réessayer." });
    }
  };

  const scrollToNext = () => {
    const nextSection = document.querySelector('.aboutus-hero-text-section');
    if (nextSection) {
      nextSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="aboutus-page">
      {/* Section hero avec vidéo en plein écran */}
      <section className="aboutus-hero-video-fullscreen">
        <div className="aboutus-hero-video-container">
          <video
            autoPlay
            loop
            muted
            playsInline
            className="aboutus-hero-video"
          >
            <source
              src="https://adawall.ma/uploads/ADAWALL%20COMPANY%20VIDEO.mp4"
              type="video/mp4"
            />
            Votre navigateur ne supporte pas la vidéo.
          </video>
          <div className="aboutus-hero-video-overlay"></div>
        </div>
        <button
          className="scroll-down-arrow"
          onClick={scrollToNext}
          aria-label="Faire défiler vers le bas"
        >
          <svg width="38" height="38" viewBox="0 0 38 38" fill="none">
            <circle cx="19" cy="19" r="19" fill="rgba(255,255,255,0.7)" />
            <path d="M12 16l7 7 7-7" stroke="#96292A" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
      </section>

      {/* Section texte "À propos de nous" */}
      <section className="aboutus-hero-text-section">
        <div className="aboutus-hero-text-content">
          <h1>À propos de nous</h1>
          <p>
            Adawall Maroc propose des revêtements muraux haut de gamme qui allient design, innovation et qualité internationale.<br />
            Nous mettons à la disposition des architectes, décorateurs et particuliers marocains des collections exclusives, des matériaux novateurs et un accompagnement personnalisé, afin de transformer chaque projet en un espace unique et raffiné.<br /><br />
            <span className="aboutus-valeurs-label">Notre mission</span> : Offrir un accès privilégié à des papiers peints et revêtements muraux d’exception, conçus pour inspirer et valoriser vos intérieurs résidentiels, professionnels ou hôteliers.<br />
            <span className="aboutus-valeurs-label">Nos valeurs</span> :<br />
            <span className="aboutus-valeur-italic">Qualité</span> : des standards élevés pour répondre aux exigences de nos clients.<br />
            <span className="aboutus-valeur-italic">Créativité</span> : des designs exclusifs inspirés des tendances mondiales.<br />
            <span className="aboutus-valeur-italic">Engagement</span> : respect de l’environnement et satisfaction client au cœur de notre démarche.
            <br /><br />
            Avec notre stock permanent à Casablanca et une équipe expérimentée, nous garantissons un service rapide, fiable et sur mesure pour accompagner vos projets à travers tout le Maroc.
          </p>
        </div>
      </section>

      {/* Section catégories */}
      <section className="aboutus-categories-section">
        <h2 className="aboutus-categories-title">Nos catégories</h2>
        <div className="aboutus-categories-grid-pro">
          {categories.map((cat, idx) => (
            <a
              className="aboutus-category-card-pro"
              href={cat.link}
              key={idx}
            >
              <div className="aboutus-category-img-pro" style={{ backgroundImage: `url(${cat.image})` }} />
              <div className="aboutus-category-separator" />
              <div className="aboutus-category-info-pro">
                <div className="aboutus-category-title-pro">{cat.title}</div>
                <div className="aboutus-category-subtitle-pro">{cat.subtitle}</div>
              </div>
            </a>
          ))}
        </div>
      </section>

      {/* Section qualités */}
      <section className="aboutus-qualities">
        <h2>Nos engagements & atouts</h2>
        <div className="aboutus-qualities-cols">
          {qualities.map((q, i) => (
            <div className="aboutus-quality" key={i}>
              <h3>{q.title}</h3>
              <div>{q.text}</div>
            </div>
          ))}
        </div>
      </section>

      {/* Section certifications avec formulaire */}
      <section className="aboutus-certif">
        <h2>Nos certifications</h2>
                <div style={{ maxWidth: 420, margin: "0 auto", background: "#fff", padding: 24, borderRadius: 8, boxShadow: "0 2px 12px rgba(1,30,69,0.06)" }}>
          {formStatus.sent ? (
          <div style={{ color: "#18884cff", fontWeight: 500, padding: "12px 0" }}>
            Merci ! Un email contenant nos certifications a été envoyé à <b><u>{email}</u></b>.<br />
            Vérifiez votre boîte de réception (et vos spams).<br /> <br />
            <span style={{ color: "#01367B", fontSize: "0.98rem" }}>
              <i>L’envoi peut prendre 1 à 2 minutes, veuillez patienter.</i>
            </span>
          </div>
          ) : (
            <>
              <p style={{ color: "#01367B", fontWeight: 500, marginBottom: 18 }}>
                Veuillez remplir ce formulaire afin de recevoir nos certifs :
              </p>
              <form onSubmit={handleCertifForm} style={{ display: "flex", flexDirection: "column", gap: 14 }}>
                <label htmlFor="certif-email" style={{ fontWeight: 500, color: "#2E2E2E" }}>
                  Adresse email :
                </label>
                <input
                  id="certif-email"
                  type="email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  placeholder="exemple@email.com"
                  required
                  style={{
                    padding: "10px 12px",
                    border: "1.5px solid #e6eaf6",
                    borderRadius: 4,
                    fontSize: "1rem",
                    outline: "none"
                  }}
                  disabled={formStatus.loading}
                />
                {formStatus.error && (
                  <div style={{ color: "#96292A", fontSize: "0.98rem" }}>{formStatus.error}</div>
                )}
                <button
                  type="submit"
                  className="certif-submit-btn"
                  disabled={formStatus.loading}
                >
                  {formStatus.loading ? "Envoi en cours..." : "Recevoir les certifications"}
                </button>
              </form>
              <div style={{ fontSize: "0.93rem", color: "#888", marginTop: 10 }}>
                Un email vous sera envoyé depuis <b>noreply@adawall.ma</b> avec nos certifications en pièce jointe.
              </div>
            </>
          )}
        </div>
      </section>

      {/* Section finale contact */}
      <section className="aboutus-end-img-btn">
        <button
          className="aboutus-contact-btn-onimg"
          onClick={() => navigate("/contact")}
        >
          Contactez-nous
        </button>
      </section>
      <a
        href="https://wa.me/212664664692"
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-float"
      >
        <img
          src="/assets/icons/whatsapp.png"
          alt="WhatsApp"
          style={{ width: 40, height: 40 }}
        />
      </a>
    </div>
  );
}

export default AboutUs;